<button
  class="cta cta--{{ kind }}"
  [ngClass]="{
    'cta--small': isSmall,
    'cta--checked': isChecked,
    'cta--disabled': disabled,
    'cta--has-count': hasCount,
    'cta--centered': centered
  }"
  (click)="onClick($event)"
  [attr.disabled]="disabled ? 'disabled' : undefined"
>
  <ng-container>
    <span
      class="cta-checkbox"
      [class.cta-checkbox--checked]="isChecked"
      aria-hidden="true"
      *ngIf="hasCheckbox"
    >
      <span class="cta-checkbox__box">
        <span class="icon icon-tick"></span>
      </span>
    </span>
  </ng-container>
  <ng-content></ng-content>
  <span *ngIf="hasCount && count">&nbsp;{{ count }} / 2</span>
</button>
